import { api } from "assets/scripts/utilities/api-clients";

export const get = async (id) => {
  const response = await api.get(`/kam/shippings/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/shippings", options);

  return response;
};

export const post = async (user) => {
  const response = await api.post("/kam/shippings", user);

  return response;
};

export const put = async (user) => {
  const response = await api.put("/kam/shippings", user);

  return response;
};
